import { Container } from 'react-bootstrap'

function About() {
  return <Container>coming soon</Container>
}

export default About
